import {
  accountCurrencyQuery,
  accountQuery,
  accountQuery_account_plan,
  accountSwitchQuery,
  getPlanGroupFeaturesQuery,
  getPlanGroupFeaturesQuery_planGroupFeatureList_features,
  plansQuery,
  plansQuery_planStacks,
  plansQuery_planStacks_plans_features,
  plansQuery_planStacks_plans_tiers,
  pricingPage_currenciesQuery,
  pricingPage_currenciesQuery_currencies,
  pricingPage_planFragment,
} from "./graphql-types";

export type AccountCurrencyQuery = accountCurrencyQuery;
export type AccountQuery = accountQuery;
export type AccountPlan = accountQuery_account_plan;
export type AccountSwitchQuery = accountSwitchQuery;

export enum BillingInterval {
  month = "month",
  year = "year",
}

export enum PlanTypeEnum {
  Free = "Free",
  Starter = "Starter",
  Professional = "Professional",
  Team = "Team",
  Company = "Company",
  Enterprise = "Enterprise",
}

export type ChangeType = "change" | "downgrade" | "upgrade";
export type CurrenciesQuery = pricingPage_currenciesQuery;
export type Currency = pricingPage_currenciesQuery_currencies;
export type FeatureListing = plansQuery_planStacks_plans_features;
export type Interval = "month" | "year";
export type Plan = pricingPage_planFragment;
export type PlansQuery = plansQuery;
export type PlanGroupFeaturesQuery = getPlanGroupFeaturesQuery;
export type PlanGroupFeature =
  getPlanGroupFeaturesQuery_planGroupFeatureList_features;
export type PlanStack = plansQuery_planStacks;
export type PlanTier = plansQuery_planStacks_plans_tiers;
export type PlanType = "Free" | "Starter" | TrialType;
export type Size = "large" | "medium" | "small";

export type TooltipPosition =
  | "northwest"
  | "north"
  | "northeast"
  | "east"
  | "southeast"
  | "south"
  | "southwest"
  | "west";

export type TrialType = "Professional" | "Team" | "Company";

export enum currencyTypeName {
  GEOLOCATED = "geolocated",
  ACCOUNT = "account",
}

export type SplitTreatment = {
  isLoading: boolean;
  treatment: string;
};

export enum SplitWorkspace {
  zapier = "zapier",
  revenue = "revenue",
}
